import { gql } from '@apollo/client';

export const QUERY_CFO_REPORTING = gql`
    query GetCFOReporting($fromDate: String!, $toDate: String!, $companyCode: String) {
        getCFOReporting(fromDate: $fromDate, toDate: $toDate, companyCode: $companyCode) {
            totalInvoices {
                label
                value
                delta
                percentageChange
            }
            totalAmount {
                label
                value
                delta
                percentageChange
            }
            successRate {
                label
                value
                delta
                percentageChange
            }
            errorRate {
                label
                value
                delta
                percentageChange
            }
            timeTrend {
                date
                invoiceCount
                previousInvoiceCount
                totalAmount
            }
            statusBreakdown {
                status
                count
                percentage
            }
            countryBreakdown {
                country
                invoiceCount
                percentage
            }
            currencyBreakdown {
                currency
                currentAmount
                previousAmount
                delta
                percentageChange
            }
            topErrorReasons {
                reason
                count
                percentage
            }
            rejectedByRecipientEstimate
        }
    }
`;
